function trimDataPathPrefix (accessor) {
  return accessor
    .replace(/^(data(\[[^\]]*\])?\.)+/, '')
    .replace(/^data$/, '')
}

// `transformCalculations` (server-side) wraps leaf calcs in `$type: 'grouping'`
// nodes recursively when `query.grouping` is set, so the leaf with the
// matching `id` can sit several levels deep in the orion request body.
function findLeafCalculation (calculations, id) {
  if (!Array.isArray(calculations)) return null
  for (const c of calculations) {
    if (c?.id === id) return c
    const nested = findLeafCalculation(c?.calculations, id)
    if (nested) return nested
  }
  return null
}

// Accepts a single request or an array of requests (pipelines can have
// multiple `/Reporting/Scope` calls); first match wins.
export function parseAccessor (accessor, orionRequest) {
  const trimmed = trimDataPathPrefix(accessor)
  if (!trimmed) return { calculationId: null, calculationType: null, field: null, trimmed }
  const [head, ...rest] = trimmed.split('.')
  const requests = Array.isArray(orionRequest) ? orionRequest : (orionRequest ? [orionRequest] : [])
  let match = null
  for (const req of requests) {
    match = findLeafCalculation(req?.calculations, head)
    if (match) break
  }
  return {
    calculationId: match?.id || head,
    calculationType: match?.$type || match?.type || null,
    matched: !!match,
    field: rest.join('.') || null,
    trimmed
  }
}
